import { LogOut01, XClose } from '@untitledui/icons'

import useRetailerApi from '@/useRetailerApi'
import useTranslation from '@/hooks/useTranslation'
import LanguageSelector from '@/components/LanguageSelector'
import Button from '@/components/Button'
import ResponsiveDrawer from '@/components/ResponsiveDrawer'

function formatShippingAddress(address) {
    if (!address) return null
    return [
        address.address1,
        address.address2,
        address.zip,
        address.city,
        address.country_code,
    ]
        .filter(Boolean)
        .join(', ')
}

function formatBillingAddress(raw) {
    if (!raw) return null
    const address = typeof raw === 'string' ? JSON.parse(raw) : raw
    return [
        address.address_line_1,
        address.address_line_2,
        address.postal_code,
        address.city,
        address.country_code,
    ]
        .filter(Boolean)
        .join(', ')
}

export default function AccountDrawer({ isOpen, onClose, onLogout }) {
    const { retailer } = useRetailerApi()
    const { t } = useTranslation()

    const shippingOneLine = formatShippingAddress(retailer?.shipping_address)
    const billingOneLine = formatBillingAddress(
        retailer?.sellsy_billing_address
    )

    return (
        <ResponsiveDrawer isOpen={isOpen} onClose={onClose} size="sm">
            <div className="flex items-center justify-between p-[24px] border-b border-dark-blue-10">
                <span className="text-[18pw] font-semibold uppercase">
                    {t('account.title')}
                </span>
                <button onClick={onClose} className="cursor-pointer">
                    <XClose size={20} />
                </button>
            </div>

            <div className="flex flex-col gap-[30px] p-[20px] flex-1">
                {retailer?.name && (
                    <div className="flex flex-col gap-[8px]">
                        <span className="text-[12px] uppercase text-dark-blue-40">
                            {t('account.name')}
                        </span>
                        <span className="text-[14px]">{retailer.name}</span>
                    </div>
                )}

                {retailer?.access_level && (
                    <div className="flex flex-col gap-[8px]">
                        <span className="text-[12px] uppercase text-dark-blue-40">
                            {t('account.role')}
                        </span>
                        <span className="text-[14px]">
                            {t(`account.accessLevel.${retailer.access_level}`)}
                        </span>
                    </div>
                )}

                {billingOneLine && (
                    <div className="flex flex-col gap-[8px]">
                        <span className="text-[12px] uppercase text-dark-blue-40">
                            {t('account.billingAddress')}
                        </span>
                        <span className="text-[14px]">{billingOneLine}</span>
                    </div>
                )}

                {shippingOneLine && (
                    <div className="flex flex-col gap-[8px]">
                        <span className="text-[12px] uppercase text-dark-blue-40">
                            {t('account.shippingAddress')}
                        </span>
                        <span className="text-[14px]">{shippingOneLine}</span>
                    </div>
                )}
            </div>

            <div className="flex flex-col gap-[16px] p-[24px]">
                <LanguageSelector fullWidth />
                <Button
                    onClick={onLogout}
                    variant="dark"
                    fullWidth
                    icon={<LogOut01 size={16} />}
                >
                    {t('common.logout')}
                </Button>
            </div>
        </ResponsiveDrawer>
    )
}
